"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtKeyCommand = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtKeyCommand = function SvgBtKeyCommand(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.625 21a2.628 2.628 0 002.625-2.625v-1.458h3.5v1.458A2.628 2.628 0 0018.375 21 2.628 2.628 0 0021 18.375a2.628 2.628 0 00-2.625-2.625h-1.458v-3.5h1.458A2.628 2.628 0 0021 9.625 2.628 2.628 0 0018.375 7a2.628 2.628 0 00-2.625 2.625v1.458h-3.5V9.625A2.628 2.628 0 009.625 7 2.628 2.628 0 007 9.625a2.628 2.628 0 002.625 2.625h1.458v3.5H9.625A2.628 2.628 0 007 18.375 2.628 2.628 0 009.625 21zm1.458-4.083v1.458a1.46 1.46 0 01-1.458 1.458 1.46 1.46 0 01-1.458-1.458 1.46 1.46 0 011.458-1.458h1.458zm7.292 0a1.46 1.46 0 011.458 1.458 1.46 1.46 0 01-1.458 1.458 1.46 1.46 0 01-1.458-1.458v-1.458h1.458zM15.75 15.75h-3.5v-3.5h3.5v3.5zm-4.667-4.667H9.625a1.46 1.46 0 01-1.458-1.458 1.46 1.46 0 011.458-1.458 1.46 1.46 0 011.458 1.458v1.458zm7.292-2.916a1.46 1.46 0 011.458 1.458 1.46 1.46 0 01-1.458 1.458h-1.458V9.625a1.46 1.46 0 011.458-1.458z",
    fill: "currentColor"
  }));
};

exports.SvgBtKeyCommand = SvgBtKeyCommand;